// extracted by mini-css-extract-plugin
export default {"skeletonlistItem":"NewsSkeleton_skeletonlistItem__YhOSX","skeletonlinks":"NewsSkeleton_skeletonlinks__byREJ","left":"NewsSkeleton_left__rIoCh","right":"NewsSkeleton_right__m6EsH"};